import { isEmpty, last } from 'lodash';
import breakpoints from '@/lib/breakpoints';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  namespaced: true,
  state: {
    count: 0,
    windowWidth: 0,
    windowHeight: 0,
    breakpoint: 'mobile',
    touchOnly: !window.matchMedia('(any-pointer: fine)').matches,
    anyTouch: window.matchMedia('(any-pointer: coarse)').matches || (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)),
    navVisible: false,
    locale: null,
  },
  mutations: {
    windowWidth(state, windowWidth) {
      state.windowWidth = windowWidth;

      state.breakpoint = last(
        Object.values(breakpoints)
          .sort((a, b) => a.index - b.index)
          .filter(entry => state.windowWidth >= entry.size),
      ).name;
    },
    windowHeight(state, windowHeight) {
      state.windowHeight = windowHeight;
    },
    navVisible(state, newValue) {
      state.navVisible = newValue;
    },
    locale(state, newValue) {
      state.locale = newValue;
    },
  },
  actions: {
    // is an action because it should be async
    navVisible(context, newValue) {
      context.commit('navVisible', newValue);
    },
  },
  getters: {
    activeBreakpoint: state => state.breakpoint,
    touchOnly: state => state.touchOnly,
    anyTouch: state => state.anyTouch,
    windowWidth: state => state.windowWidth,
    navVisible: state => state.navVisible,
    locale: state => state.locale,
  },
};



// WEBPACK FOOTER //
// ./src/stores/Layout.js